(function () {
  'use strict';

  if (window.UnifiedAttributionContext) {
    return;
  }

  const VERSION = '1.0.0';

  function getConfig() {
    const project = window.UnifiedProjectConfig || {};
    return project.attribution || {};
  }

  function analyticsAllowed() {
    return Boolean(
      window.UnifiedConsent &&
      typeof window.UnifiedConsent.analyticsAllowed === 'function' &&
      window.UnifiedConsent.analyticsAllowed() === true
    );
  }

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function storageRemove(key) {
    try {
      window.localStorage.removeItem(key);
      return true;
    } catch (error) {
      return false;
    }
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function normalizeSku(value) {
    return String(value || '').trim();
  }

  function parse(value) {
    if (!value) return null;

    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
        ? parsed
        : null;
    } catch (error) {
      return null;
    }
  }

  function isExpired(context) {
    if (!context || !context.expires_at) return true;
    const expiresAt = Date.parse(context.expires_at);
    return !Number.isFinite(expiresAt) || expiresAt <= Date.now();
  }

  function clear() {
    const key = getConfig().storageKey || 'ut_attribution_context';
    return storageRemove(key);
  }

  function get() {
    if (!analyticsAllowed()) {
      clear();
      return null;
    }

    const key = getConfig().storageKey || 'ut_attribution_context';
    const context = parse(storageGet(key));

    if (!context) {
      return null;
    }

    if (isExpired(context)) {
      storageRemove(key);
      return null;
    }

    return Object.assign({}, context);
  }

  function snapshot() {
    const context = get();

    if (!context) {
      return {};
    }

    return {
      first_meaningful_source: context.first_meaningful_source || '',
      last_meaningful_source: context.last_meaningful_source || '',
      last_product_sku: context.last_product_sku || '',
      last_product_source: context.last_product_source || '',
      recommendation_source: context.recommendation_source || ''
    };
  }

  function record(input) {
    if (!analyticsAllowed()) {
      return false;
    }

    const source = input || {};
    const mechanism = normalize(source.source_mechanism);

    if (!mechanism) {
      return false;
    }

    const config = getConfig();
    const key = config.storageKey || 'ut_attribution_context';
    const ttlMs = Number(config.ttlMs) || (30 * 24 * 60 * 60 * 1000);
    const now = Date.now();
    const existing = get();
    const productSku = normalizeSku(source.product_sku);
    const recommendationSource = normalize(source.recommendation_source);

    const next = {
      version: VERSION,
      set_at: existing && existing.set_at
        ? existing.set_at
        : new Date(now).toISOString(),
      updated_at: new Date(now).toISOString(),
      expires_at: new Date(now + ttlMs).toISOString(),
      first_meaningful_source:
        existing && existing.first_meaningful_source
          ? existing.first_meaningful_source
          : mechanism,
      last_meaningful_source: mechanism,
      last_product_sku:
        productSku || (existing && existing.last_product_sku) || '',
      last_product_source:
        productSku ? mechanism : (existing && existing.last_product_source) || '',
      recommendation_source:
        recommendationSource || (existing && existing.recommendation_source) || ''
    };

    if (!storageSet(key, JSON.stringify(next))) {
      return false;
    }

    return Object.assign({}, next);
  }

  window.UnifiedAttributionContext = {
    version: VERSION,
    record: record,
    get: get,
    snapshot: snapshot,
    clear: clear
  };
})();
